import React, { useState } from 'react';
import * as PropTypes from 'prop-types';
import CSSModules from 'react-css-modules';

import ClickableElement from '../../ClickableElement';
import PopoverMenu from '../../common/PopoverMenu';
import { IDS } from '../../../constants/ids';
import Icon from '../../Icon';
import AssignMenuList from './AssignMenuList';
import styles from '../index.styl';

const AssignBtn = ({ isProvider }) => {
  const [open, setOpened] = useState(false);
  const [anchor, setAnchor] = useState();
  const handleOpenPopover = e => {
    setOpened(true);
    setAnchor(e.currentTarget);
  };

  const handleClosePopover = () => {
    setOpened(false);
    setAnchor(null);
  };

  return (
    <div styleName="item">
      <ClickableElement
        id={IDS.NAV_BAR.OPEN_JOIN_POPUP}
        onClick={handleOpenPopover}
        className="ph3"
        styleName="link"
        ariaLabel="assign patient"
      >
        <Icon name="assign-patient" size={36} />
      </ClickableElement>

      <AssignMenuList
        selectItem={handleClosePopover}
        isProvider={isProvider}
        renderItems={items => (
          <PopoverMenu
            style={{ marginTop: '-10px' }}
            size="large"
            isOpen={open}
            anchorEl={anchor}
            items={items}
            onClose={handleClosePopover}
          />
        )}
      />
    </div>
  );
};

AssignBtn.propTypes = {
  isProvider: PropTypes.bool,
};

export default CSSModules(AssignBtn, styles, { allowMultiple: true });



// WEBPACK FOOTER //
// ./src/components/Header/Components/AssignBtn.jsx